<template>
  <div>
    <EvangelioList />
  </div>
</template>

<script>
import EvangelioList from '@/components/EvangelioList.vue';
  export default {
    components: {
      EvangelioList
    }
  }
</script>

<style scoped>

</style>